import client from "./axios";

const agentsUrl = `${window.__env.KRAKEND_URL}/v1/agents`;

export interface AgentGenerationResponse {
  id: string;
  messages: AgentMessage[];
  status: { state: string };
}

export interface GenerationResponseText {
  Description: string;
  Tags?: string[];
}

interface AgentMessage {
  parts: { text: string }[];
  role: string;
}

interface GenerationBodyDetails {
  id: string;
  message: AgentMessage;
}

export interface AgentGenerationBody {
  redisNamespace: string;
  redisKey: string;
  details: GenerationBodyDetails;
}

export const Agents = {
  generate: (body: AgentGenerationBody) => client.post<AgentGenerationResponse>(agentsUrl, body),
}